import {ScarcityElement as UIScarcityElement} from '@travel-frontend/ui-components';
import {Trans, useTranslation} from 'react-i18next';

import {PAGE_OFFERS} from '@/consts';
import {Container} from '@/modules/common/components/ScarcityElement/components/Container';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';
import {useScarcityElement} from '@/modules/common/hooks/useScarcityElement';

export const ScarcityElement = () => {
  const {t} = useTranslation();
  const currentPage = useCurrentPage();
  const {isLoading, content, count} = useScarcityElement();
  const titleContext =
    currentPage === PAGE_OFFERS && content === 'scarcityElement.dynamic.content'
      ? currentPage
      : '';

  if (isLoading || !content) {
    return null;
  }

  return (
    <Container>
      <UIScarcityElement
        ariaLabel={t('general:scarcityElement.ariaLabel')}
        storageKey="offerScarcityElementDismissedAt"
        title={
          <Trans
            ns="general"
            i18nKey="scarcityElement.title"
            context={titleContext}
          />
        }
        content={
          <Trans
            ns="general"
            i18nKey={content}
            context={currentPage}
            values={{count}}
            components={{bold: <b />}}
          />
        }
        isDynamic={content === 'scarcityElement.dynamic.content'}
      />
    </Container>
  );
};
